import React, { useState } from 'react';
import { IMedia } from '../../common/types';
import { Typography } from '@unfold/typography';
import { ColorsContainer, AddCard } from './styled';

import { Color } from './color';
import { Modal } from '@unfold/modal';
import { AddColor } from './add-color';
import { useBrandKitState } from '../../store';
import { SectionWrapper } from '../../common/styled';

interface IColorsProps {
  colors: IMedia[];
  isLoading: boolean;
}

export const Colors: React.FC<IColorsProps> = ({ colors, isLoading }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [, actions] = useBrandKitState();

  const handleModalClose = (): void => {
    setModalOpen(false);
  };

  const handleColorAdded = (color: string): void => {
    actions.addColor(color);
    setModalOpen(false);
  };

  const handleRemove = (id: string): void => {
    actions.removeMedia(id);
  };

  return (
    <>
      <SectionWrapper css={{ paddingTop: 52 }}>
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <>
            <Typography variant="H700">Colors</Typography>
            <ColorsContainer>
              {colors.map((color) => (
                <Color key={color.uuid} color={color} onRemove={handleRemove} />
              ))}
              <AddCard
                variant="outlined"
                css={{ height: 185 }}
                onClick={(): void => setModalOpen(true)}
              >
                <Typography
                  variant="H400"
                  customColor={{ light: '#717171', dark: '#fff' }}
                >
                  Add
                </Typography>
              </AddCard>
            </ColorsContainer>
          </>
        )}
      </SectionWrapper>
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        width={370}
        title="Add Color"
      >
        <AddColor
          onColorAdded={handleColorAdded}
          onCancelClick={handleModalClose}
        />
      </Modal>
    </>
  );
};
